import * as moment from 'moment';

import * as fromAccountInformationActions from '../actions/account-information.actions';
import { Account } from '../../model/account';
import { AccountType } from '../../account-types.enum';

export const expiredAccountTypes: Array<string> = [
  AccountType.SUSPENDED,
  AccountType.CANCELLED,
  AccountType.INVALID,
  AccountType.BLOCKED
];
const blockedAccountTypes: Array<AccountType> = [
  AccountType.SUSPENDED,
  AccountType.DUPLICATED,
  AccountType.INVALID,
  AccountType.BLOCKED
];

export interface AccountInformationState {
  entity: Account;
  managerAccess: boolean;
  loaded: boolean;
  loading: boolean;
}

export const accountInformationInitialState: AccountInformationState = {
  entity: {} as Account,
  managerAccess: false,
  loaded: false,
  loading: false
};

export function reducer(
  state: AccountInformationState = accountInformationInitialState,
  action: fromAccountInformationActions.AccountActions
): AccountInformationState {
  switch (action.type) {
    case fromAccountInformationActions.LOAD_ACCOUNT_INFORMATION: {
      return {
        ...state,
        loaded: false,
        loading: true
      };
    }

    case fromAccountInformationActions.LOAD_ACCOUNT_INFORMATION_SUCCESS: {
      const account: Account = action.payload;
      const managerAccess: boolean = hasManagerAccess(account);

      return {
        ...state,
        entity: account,
        managerAccess,
        loaded: true,
        loading: false
      };
    }

    case fromAccountInformationActions.LOAD_ACCOUNT_INFORMATION_FAIL: {
      console.error('fail', action.payload);
      return {
        ...state
      };
    }
  }

  return state;
}

function hasManagerAccess(account: Account): boolean {
  if (
    account.type === AccountType.FREEACCOUNT &&
    account.expirationDate.isBefore(moment())
  ) {
    return false;
  } else {
    return !blockedAccountTypes.includes(account.type);
  }
}

export const getAccountInformationEntity: any = (
  state: AccountInformationState
): Account => state.entity;
export const getAccountInformationLoaded: any = (
  state: AccountInformationState
): boolean => state.loaded;
export const getAccountInformationLoading: any = (
  state: AccountInformationState
): boolean => state.loading;
export const getHasManagerAccess: any = (
  state: AccountInformationState
): boolean => state.managerAccess;
